<template>
  <div class='EnbFooter01'
  v-if="$route.path === '/' || $route.path === '/loja'"
  :style="{
    backgroundColor: Prefes.rodape.corBackground,
    color: Prefes.rodape.corFont,
    fontFamily: Prefes.rodape.font,
    fontStyle: parseInt(Prefes.rodape.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.rodape.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.rodape.textDecoration) ? 'underline' : '',
    fontSize: Prefes.rodape.fontHeight + 'px'
  }"
  >
    <widget-rede color="#FFFFFF"/>
    <div class="enbC" style="font-size: 10px;">
      ENB Business © 2022
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WidgetRede from '../Widget/WidgetRede'
export default {
  name: 'EnbFooter01',
  components: { WidgetRede },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.EnbFooter01 {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding-top: 1%;
  padding-bottom: 1%;
  background-color: #333333;
  color: #FFFFFF;
  font-size: 12px;
}

.enbC {
  padding-top: 2%;
}

@media screen and (max-width: 500px) {
  .EnbFooter01 {
    padding-bottom: 25%;
  }
}
</style>
